module.exports = __webpack_public_path__ + "media/images/athletes/2193-0b307cb428328ce3d72669d3b2660133.png";